/*
 * @Author: zhangpengfei 17739673757@163.com
 * @Date: 2023-11-23 13:37:49
 * @LastEditors: zhangpengfei 17739673757@163.com
 * @LastEditTime: 2023-12-25 14:59:11
 * @FilePath: \ZZU_Admin\src\api\base.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 接口域名的管理
 */
const base = {
  // sq: 'http://114.116.206.115:6002/api',
  // qa: 'http://114.116.206.115:6001/api'
  sq: 'https://zzuauth.hmcyhpg.com/api',
  qa: 'https://zzuapi.hmcyhpg.com/api'
  // sq: 'https://zdjcxyu-api-auth.dev.hmcyhpg.com/api', //登录
  // qa: 'https://zdjcxyu-api.dev.hmcyhpg.com/api' //接口
  // sq: 'https://vrjx.zzu.edu.cn:8010/api', //登录登出地址
  // qa: 'https://vrjx.zzu.edu.cn:8009/api' //其余通用地址
}

export default base
